module.exports = __webpack_public_path__ + "img/campaign_03.b8aaef6f.png";